import { Li } from '../../layouts/LayoutTable/LayoutTable'
import { Label } from '../BelowInput/BelowInput.style'
import { Checkbox } from '../Checkbox/Checkbox'
import { DivLabel } from '../Pagination/Pagination.style'

type ItemFilterProps = {
  checked?: boolean
  onChange: () => void
  text: string
  id: string
  colors?: 'fonteColor'
  top: string
  disabled?: boolean
  bloqueado?: string
}

export function ItemFilter({
  checked,
  onChange,
  text,
  id,
  colors,
  top,
  disabled,
  bloqueado,
}: ItemFilterProps) {
  return (
    <Li>
      <Checkbox
        top={top}
        id={id}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        bloqueado={bloqueado}
      />
      <DivLabel>
        <Label color={colors} htmlFor={id}>
          {text}
        </Label>
      </DivLabel>
    </Li>
  )
}
